import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/tipoActivo/importer/tipoActivoImporterActions';

export default importerReducers(actions);
